export class Parametro{
	constructor(
	    	public id: String = "",
            public nombre: String = "",
            public valor: String = "",
			//public usuario_elim_id: String = "",
			public usuario_id: String = null,
	){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/parametro.ts